import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userInfo: {
    email: "",
    firstName: "",
    lastName: "",
    MCID: "",
    UID: "",
    WialonToken: "",
    ECTSCompId: "",
    COMPNAME: "",
    SYSADM: ""
  },
  vehiclesToRender: [],
  isDeviceInfoActive:false,
  isDeviceTrackingActive:false,
  floatingModalData :{},
  selectedID : null,
   ToggleFreeze: false,
  consignerList: [],
  smsTemplate: [],
  transporterList: [],
  consigneeList: [],
  userList: [],
  vehicleList: [],
  vehicleType: [],
  officeList: [],
  roleList: [],
  supllierList: [],
  countryList: [],
  kpiNameList: [],
  driverList: [],
  respientList: [],
  allEntityList: [],
  latlongList: [],
  driverWithVehicle: [],
  isLoggedIn: true,
  routeList: [],
  deviceList: [],
  companyList: [],
  vehicleLists: [],
  tripMonitorData: [],
  subscriptionList:[],
  userPermissionList: [],
  AICompanyList:[],
  fenceList: [],
  nexusFenceList: [],
  popupOpen: false,
  selectedDevice: null, 
   selectedId: null,
    isUnlockConfirmVisible: false,
     unlockConfirmDevice: null,
      livemapLocationName: "Loading...",
      panelType: "info",
        selectedLocation: null,
          statustime: "",
            isInfoActive: false, 
  isTrackingActive: false, 
  viewport: {
    latitude: -1.2921, 
    longitude: 36.8219,
    zoom: 8,
    transitionDuration: 500,
    loading: false,
     popupData: {
      title: "",
      content: "",
      notes: "",
    },
    position: { x: 100, y: 100 },
    isOpen: false,
    isMinimized: false,
    DeviceTorender : [],
    DevicerenderinfoPanel : [] ,
    open : false,
  },
};




export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
          setDevicerenderInfoPanel: (state, action) => {
      state.DevicerenderinfoPanel = action.payload ;
    },
       setDeviceToRender: (state, action) => {
      state.DeviceTorender = action.payload ;
    },
       setPopupData: (state, action) => {
      state.popupData = { ...state.popupData, ...action.payload };
    },
    setPosition: (state, action) => {
      state.position = action.payload;
    },
    setIsOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setIsMinimized: (state, action) => {
      state.isMinimized = action.payload;
    },
    setUnlockConfirmDevice: (state, action) => {
      state.unlockConfirmDevice = action.payload;
    },
      setLoading: (state, action) => { 
      state.loading = action.payload;
    },
      setViewport: (state, action) => { 
      state.viewport = action.payload;
    },

     setIsInfoActive: (state, action) => { 
      state.isInfoActive = action.payload;
    },
    
    setIsTrackingActive: (state, action) => { 
      state.isTrackingActive = action.payload;
    },
       setStatustime: (state, action) => {
      state.statustime = action.payload;
    },
      setSelectedLocation: (state, action) => { 
      state.selectedLocation = action.payload;
    },
     setPanelType: (state, action) => { 
      state.panelType = action.payload; 
    },
      setSelectedId: (state, action) => { 
      state.selectedId = action.payload;
    },
     setLiveMapLocationName: (state, action) => { 
      state.livemapLocationName = action.payload;
    },
    setFloatingModalData: (state, action) => {
  return {
    ...state,
    floatingModalData: action.payload,
  };
},
 setIsUnlockConfirmVisible: (state, action) => { 
      state.isUnlockConfirmVisible = action.payload;
    },
      setUnlockConfirmDevice: (state, action) => { 
      state.unlockConfirmDevice = action.payload;
    },
 
      setVehiclesToRender: (state, action) => {
      state.vehiclesToRender = action.payload;
    },
    
    setToggleFreeze: (state, action) => {
      return {
        ...state,
        ToggleFreeze: action.payload,
      };
    },
    freeze: (state) => {
      state.ToggleFreeze = true;
    },
    unfreeze: (state) => {
      state.ToggleFreeze = false;
    }
,   setUserInfo: (state, action) => {
      return {
        ...state,
        userInfo: action.payload,
      };
    },
  setSelectedDevice: (state, action) => {
      state.selectedDevice = action.payload;
    },
    
    setUserList: (state, action) => {
      return {
        ...state,
        userList: action.payload,
      };
    },

    setSmsTemplate: (state, action) => {
      return {
        ...state,
        smsTemplate: action.payload,
      };
    },

    setConsignerList: (state, action) => {
      return {
        ...state,
        consignerList: action.payload,
      };
    },
    setTransporterList: (state, action) => {
      return {
        ...state,
        transporterList: action.payload,
      };
    },
    setConsigneeList: (state, action) => {
      return {
        ...state,
        consigneeList: action.payload,
      };
    },
    setVehicleList: (state, action) => {
      return {
        ...state,
        vehicleList: action.payload,
      };
    },
    setVehicleType: (state, action) => {
      return {
        ...state,
        vehicleType: action.payload,
      };
    },
    ssetOfficeList: (state, action) => {
      return {
        ...state,
        officeList: action.payload,
      };
    },
    setRoleList: (state, action) => {
      return {
        ...state,
        roleList: action.payload,
      };
    },
    setSupllierList: (state, action) => {
      return {
        ...state,
        supllierList: action.payload,
      };
    },
    setCountryList: (state, action) => {
      return {
        ...state,
        countryList: action.payload,
      };
    },
    setKpiNameList: (state, action) => {
      return {
        ...state,
        kpiNameList: action.payload,
      };
    },
    setDriverList: (state, action) => {
      return {
        ...state,
        driverList: action.payload,
      };
    },
    setAllEntityList: (state, action) => {
      return {
        ...state,
        allEntityList: action.payload,
      };
    },
    setRespientList: (state, action) => {
      return {
        ...state,
        respientList: action.payload,
      };
    },
    setLatLongList: (state, action) => {
      return {
        ...state,
        latlongList: action.payload,
      };
    },
    setDriverWithVehicle: (state, action) => {
      return {
        ...state,
        driverWithVehicle: action.payload,
      };
    },
    setRouteList: (state, action) => {
      return {
        ...state,
        routeList: action.payload,
      };
    },

    setDeviceList: (state, action) => {
      return {
        ...state,
        deviceList: action.payload,
      };
    },
    setCompanyList:(state, action) => {
      return {
        ...state,
        companyList: action.payload,
      };
    },
    setVehicleLists: (state, action) => {
      return {
        ...state,
        vehicleLists: action.payload,
      };
    },
    setTripMonitorData: (state, action) => {
      return {
        ...state,
        tripMonitorData: action.payload,
      };
    },
    setSubscriptionList:(state, action) => {
      return {
        ...state,
        subscriptionList: action.payload,
      };
    },
    setUserPermissionList:(state, action) => {
      return {
        ...state,
        userPermissionList: action.payload,
      };
    },
    setMyPermissionList:(state, action) => {
      return {
        ...state,
        myPermissionList: action.payload,
      };
    },
    setAICompanyList:(state, action) => {
      return {
        ...state,
        AICompanyList: action.payload,
      };
    },
    setAIVehicleLists:(state, action) => {
      return {
        ...state,
        AIVehicleLists: action.payload,
      };
    },
    setFenceList:(state, action) => {
      return {
        ...state,
        fenceList: action.payload,
      };
    },
    setNexusFenceList:(state, action) => {
      return {
        ...state,
        nexusFenceList: action.payload,
      };
    },
    setSelectedID:(state, action) => {
      console.log(state, action , "bwhjss")
      return {
        ...state,
        selectedID: action.payload,
      };
    },
     setpopupOpen:(state, action) => {
      console.log(state, action , "bwhjss")
      return {
        ...state,
        popupOpen: action.payload,
      };
    },
      setIsDeviceTrackingActive:(state, action) => {
      console.log(state, action , "bwhjss")
      return {
        ...state,
        isDeviceTrackingActive: action.payload,
      };
    },
       setIsDeviceInfoActive  :(state, action) => {
      console.log(state, action , "bwhjss")
      return {
        ...state,
        isDeviceInfoActive: action.payload,
      };
    },
       setComponent: (state, action) => { 
      state.component = action.payload;
    },
    
       setOpen: (state, action) => { 
      state.open = action.payload;
    },
  },
  
});

export const {
  setVehiclesToRender ,
  setIsDeviceInfoActive,
  setIsDeviceTrackingActive,
  setSelectedID, 
  setToggleFreeze, 
  setTripMonitorData,
  setVehicleLists,
  setCompanyList,
  setDeviceList,
  setRouteList,
  setUserInfo,
  setUserList,
  setSmsTemplate,
  setConsignerList,
  setTransporterList,
  setConsigneeList,
  setVehicleList,
  setVehicleType,
  ssetOfficeList,
  setRoleList,
  setSupllierList,
  setCountryList,
  setKpiNameList,
  setDriverList,
  setRespientList,
  setAllEntityList,
  setLatLongList,
  setDriverWithVehicle,
  setSubscriptionList,
  setUserPermissionList,
  setMyPermissionList,
  setAICompanyList,
  setAIVehicleLists,
  setFenceList,
  setNexusFenceList,
  setFloatingModalData,
  setpopupOpen ,
    setSelectedDevice,
      setUnlockConfirmDevice,
       setIsUnlockConfirmVisible,
         setSelectedId,
          setLiveMapLocationName, 
           setPanelType,
            setSelectedLocation,
              setStatustime,
  setIsInfoActive, 
  setIsTrackingActive, 
   setViewport, 
     setLoading, 
       setComponent,
       setIsOpen,
       setIsMinimized,
       setPosition,
       setPopupData ,
       setDeviceToRender, 
setDevicerenderInfoPanel,
setOpen
} = authSlice.actions;

export const authReducer = authSlice.reducer;
